import React, { useState, useEffect } from 'react';
import { useDragAndDrop } from 'src/hooks/useDragAndDrop';
import SearchableSelect from 'src/Components/Common/SearchableSelect/SearchableSelect';
import { InputSection, Label, ProviderInfoBox, ProviderInfoItem, ProviderInfoLabel, ProviderInfoValue, TextArea, } from '../sharedModalStyles';
import { ModalLayout, DocumentsSectionComponent } from '../sharedModalComponents';
import { useProviderOptions } from 'src/Utils/hooks/useProviderOptions';
var typeConfig = {
    claim: {
        title: 'Realizar Reclamo',
        confirmLabel: 'Enviar Reclamo',
    },
    budget_request: {
        title: 'Solicitar Presupuesto',
        confirmLabel: 'Solicitar Presupuesto',
    },
};
var ProviderModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, ticket = _a.ticket, type = _a.type, onConfirm = _a.onConfirm, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b;
    var _c = useDragAndDrop(), files = _c.files, addFiles = _c.addFiles, clearFiles = _c.clearFiles, removeFile = _c.removeFile;
    var _d = useState(null), providerId = _d[0], setProviderId = _d[1];
    var _e = useState(''), internalComment = _e[0], setInternalComment = _e[1];
    var providers = useProviderOptions().providers;
    var selectedProvider = providers.find(function (p) { return p.id === providerId; });
    var config = typeConfig[type];
    useEffect(function () {
        if (ticket.provider_service && providers.length > 0 && !providerId) {
            var matchingProvider = providers.find(function (p) { return p.type_of_service === ticket.provider_service; });
            if (matchingProvider) {
                setProviderId(matchingProvider.id);
            }
        }
    }, [ticket.provider_service, providers, providerId]);
    useEffect(function () {
        if (!isOpen) {
            clearFiles();
            setProviderId(null);
            setInternalComment('');
        }
    }, [isOpen, clearFiles]);
    var handleFilesSelected = function (newFiles) {
        addFiles(newFiles);
    };
    var handleConfirm = function () {
        if (providerId) {
            onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(providerId, internalComment.trim(), files);
        }
    };
    var handleClose = function () {
        clearFiles();
        setProviderId(null);
        setInternalComment('');
        onClose();
    };
    return (React.createElement(ModalLayout, { isOpen: isOpen, onClose: handleClose, title: config.title, ticket: ticket, confirmButtonLabel: config.confirmLabel, onConfirm: handleConfirm, isConfirmDisabled: !providerId, isLoading: isLoading },
        React.createElement(InputSection, null,
            React.createElement(Label, null,
                "Proveedor",
                React.createElement("span", null, " (obligatorio)")),
            React.createElement(SearchableSelect, { value: providerId, onChange: function (value) {
                    return setProviderId(value ? value : null);
                }, options: providers.map(function (provider) { return ({
                    value: provider.id,
                    label: provider.name,
                }); }), placeholder: "Selecciona un proveedor" })),
        selectedProvider && (React.createElement(ProviderInfoBox, null,
            React.createElement(ProviderInfoItem, null,
                React.createElement(ProviderInfoLabel, null, "Tel\u00E9fono"),
                React.createElement(ProviderInfoValue, null, selectedProvider.phone || 'N/A')))),
        React.createElement(InputSection, null,
            React.createElement(Label, null, "Comentarios"),
            React.createElement(TextArea, { value: internalComment, onChange: function (e) { return setInternalComment(e.target.value); }, placeholder: "Escrib\u00ED ac\u00E1 tus comentarios...", rows: 4 })),
        React.createElement(DocumentsSectionComponent, { files: files, onFilesSelected: handleFilesSelected, onRemoveFile: removeFile })));
};
export default ProviderModal;
